/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { PutUsersIdMutationRequest, PutUsersIdMutationResponse, PutUsersIdPathParams, PutUsersId400, PutUsersId403 } from '../entities/PutUsersId'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import { putUsersId } from '../api/putUsersId'
import { useMutation } from '@tanstack/react-query'

export const putUsersIdMutationKey = () => [{ url: '/users/{id}' }] as const

export type PutUsersIdMutationKey = ReturnType<typeof putUsersIdMutationKey>

/**
 * @description Обновление пользователя админом компании
 * @summary Обновление пользователя
 * {@link /users/:id}
 */
export function usePutUsersId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutUsersIdMutationResponse,
      ResponseErrorConfig<PutUsersId400 | PutUsersId403>,
      { id: PutUsersIdPathParams['id']; data: PutUsersIdMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<PutUsersIdMutationRequest>> & { client?: typeof client }
  } = {},
) {
  const { mutation: { client: queryClient, ...mutationOptions } = {}, client: config = {} } = options ?? {}
  const mutationKey = mutationOptions?.mutationKey ?? putUsersIdMutationKey()

  return useMutation<
    PutUsersIdMutationResponse,
    ResponseErrorConfig<PutUsersId400 | PutUsersId403>,
    { id: PutUsersIdPathParams['id']; data: PutUsersIdMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ id, data }) => {
        return putUsersId(id, data, config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}